import { Directive, effect, input, output } from '@angular/core';
import { Subscription } from 'rxjs';

import { intersectionRxUtils } from '@blaze-shared/shared-util';

@Directive({
  selector: '[blazeDropdownInfiniteScroll]',
})
export class DropdownInfiniteScrollDirective {
  terminatorElement = input<HTMLElement | undefined>(undefined, {
    alias: 'blazeDropdownInfiniteScroll',
  });
  scrollOffset = input(50);
  enabled = input(true, { alias: 'blazeDropdownInfiniteScrollEnabled' });

  scrollBottom = output();

  private subscription = Subscription.EMPTY;

  constructor() {
    effect((onCleanup) => {
      const element = this.terminatorElement();

      if (!element) {
        this.subscription.unsubscribe();
        return;
      }

      this.subscription = this.observeTerminator(element);

      onCleanup(() => {
        this.subscription.unsubscribe();
      });
    });
  }

  private observeTerminator(terminator: HTMLElement): Subscription {
    this.subscription.unsubscribe();

    const options: IntersectionObserverInit = {
      root: null,
      threshold: 0.01,
      rootMargin: `0px 0px ${this.scrollOffset()}px 0px`,
    };

    return intersectionRxUtils.fromIntersectionObserver(terminator, options).subscribe({
      next: (entries) => {
        if (this.enabled() && entries.some((e) => e.isIntersecting)) {
          this.scrollBottom.emit();
        }
      },
    });
  }
}
